import { Box, Typography } from "@mui/material";
import React from "react";

const TermsAndCondition = () => {
  return (
    <Box sx={{ mt: 5 }}>
      <Typography sx={{ fontSize: 16, fontWeight: 600, color: "grey" }}>
        Terms and Conditions
      </Typography>
      <Typography sx={{ fontSize: 14 }}>
        Membership Joining fees are not refundable once paid. <br />
        Membership fees can be transferred to other members if opt for refund.{" "}
        <br />
        Membership period freeze is allowed up to one month period.
      </Typography>
    </Box>
  );
};

export default TermsAndCondition;
